import React from "react"
import "./successTick.css"
import Lottie from "react-lottie"
import { successTick } from "../../animation"

interface SuccessTickProps {
  message: string
  proceedMessage: string
  visible: boolean
}

export default class SuccessTick extends React.Component<SuccessTickProps, {}> {
  render() {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: this.props.visible ? successTick : "",
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    }

    return (
      <>
        {this.props.visible && (
          <div className="success-tick-overview">
            <div className="success-tick">
              <Lottie options={defaultOptions} width="7em" height="7em" />
              <div className="success-tick-message">{this.props.message}</div>
              {this.props.proceedMessage && (
                <div className="success-proceed-text">
                  {this.props.proceedMessage}
                </div>
              )}
            </div>
          </div>
        )}
      </>
    )
  }
}
